import { useEffect } from 'react';

export const useBeforeUnload = ({ shouldPrompt, action }: { shouldPrompt: boolean; action?: () => void }) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!shouldPrompt) {
        return;
      }
      if (action) {
        action();
      }
      event.preventDefault();
      event.returnValue = ''; // Required for Chrome to show the prompt
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldPrompt, action]);
};
